import React, { useState } from "react";
import { X } from "lucide-react";
import { siteData } from "../mock";

export default function GalleryPage() {
  const [open, setOpen] = useState(null);
  return (
    <>
      <section className="py-20 md:py-28 bg-jk-cream border-b border-[#e7e2d7]">
        <div className="max-w-7xl mx-auto px-5 md:px-10">
          <div className="text-[11px] tracking-[0.32em] text-[#b88b4a] mb-5">GALLERY</div>
          <h1 className="font-serif text-neutral-900 text-[44px] md:text-[76px] leading-[1.03] tracking-tight max-w-5xl">
            JK Estates <span className="italic">— office &amp; on-ground.</span>
          </h1>
          <p className="mt-7 text-neutral-700 text-[16px] md:text-[18px] leading-[1.85] max-w-3xl">
            Snapshots from our Mohali office, active projects and site visits across the Tricity. Click any image to open the full preview.
          </p>
        </div>
      </section>

      <section className="py-20 md:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-5 md:px-10">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
            {siteData.gallery.map((g, i) => (
              <button
                key={i}
                onClick={() => setOpen(i)}
                className="group relative aspect-[4/5] overflow-hidden bg-[#0f1a2e] border border-[#e7e2d7]"
              >
                <img src={g.src} alt={g.alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.05]" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent" />
                <div className="absolute bottom-3 left-3 right-3 text-white text-[11.5px] tracking-wide opacity-0 group-hover:opacity-100 transition-opacity">{g.alt}</div>
              </button>
            ))}
          </div>
        </div>
      </section>

      {open !== null && (
        <div className="fixed inset-0 z-[60] bg-black/88 flex items-center justify-center p-4" onClick={() => setOpen(null)}>
          <button onClick={() => setOpen(null)} className="absolute top-5 right-5 w-11 h-11 bg-white/10 hover:bg-white/20 text-white flex items-center justify-center" aria-label="Close">
            <X className="w-5 h-5" />
          </button>
          <img src={siteData.gallery[open].src} alt={siteData.gallery[open].alt} className="max-w-full max-h-[88vh] object-contain" onClick={(e) => e.stopPropagation()} />
        </div>
      )}
    </>
  );
}
